import React, { useState } from 'react';
import { sendVerificationCode } from '../services/authService';
import ReCAPTCHA from 'react-google-recaptcha';
import CONFIG from '../config/config';
import styles from '../signin.module.css';

const SignIn = ({ onNextStep }) => {
    const [email, setEmail] = useState('');
    const [captchaToken, setCaptchaToken] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        if (!captchaToken) {
            setError('Please complete the CAPTCHA.');
            setLoading(false);
            return;
        }

        try {
            await sendVerificationCode(email);
            onNextStep(email); // Proceed to verification step
        } catch (err) {
            setError('Failed to send verification code. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleCaptchaChange = (token) => {
        setCaptchaToken(token);
    };

    return (
        <div className={styles.container}>
            <form onSubmit={handleSubmit}>
                <label htmlFor="email" className={styles.label}>Enter your email</label>
                <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoComplete="off"
                    className={styles.input}
                />
                <ReCAPTCHA
                    sitekey={CONFIG.GOOGLE.SITE_KEY_V2}
                    onChange={handleCaptchaChange}
                />
                <button
                    type="submit"
                    disabled={loading}
                    className={styles.button}
                >
                    {loading ? 'Sending...' : 'Send Code'}
                </button>
                {error && <p className={styles.error}>{error}</p>}
            </form>
        </div>
    );
};

export default SignIn;